export default "__VITE_ASSET__Dd04ZoSn__"